import styled, { keyframes } from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

const FadeInKeyframes = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const DEIPageBarChartBarDIV = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  padding: 0 15px;
  transform: translateZ(0);
  transition: all 0.3s;
  /* max-width: 200px; */

  strong {
    display: block;
    margin: 0 0 20px;
  }

  h4 {
    font-weight: var(--font-weight--normal);
    font-family: var(--font-family--sans);
    font-size: var(--font-size--L);
    color: var(--color--text-default);
    animation: ${FadeInKeyframes} 0.5s forwards;
    text-align: left;
    writing-mode: vertical-lr;

    ${MEDIA_QUERIES.M} {
      text-align: center;
      writing-mode: initial;
    }
  }
`;

export const DEIPageBarChartBarWrapperDIV = styled.div`
  height: 341px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 15px;

  ${MEDIA_QUERIES.M} {
    margin-bottom: 30px;
  }
`;

export const DEIPageBarChartBarBarDIV = styled.div`
  border-radius: 4px 4px 0 0;
  width: 10vw;
  min-width: 40px;
  max-width: 107px;
  transform: translateZ(0);
  transition: height 0.3s;
`;
